module.exports = __webpack_public_path__ + "img/lite_example.0ab38002.png";